const getTrafficLevels = (self) => [
  { key: 'faster', label: `55 - 78 ${self.$t('global.unit.kmPerHour')}` },
  { key: 'fast', label: `44 - 62 ${self.$t('global.unit.kmPerHour')}` },
  { key: 'normal', label: `35 - 50 ${self.$t('global.unit.kmPerHour')}` },
  { key: 'slow', label: `26 - 38 ${self.$t('global.unit.kmPerHour')}` },
  { key: 'very slow', label: `20 - 28 ${self.$t('global.unit.kmPerHour')}` },
]

export default getTrafficLevels
